import { segmentsListContract } from "@domains/segments/shared/segmentsListContract.ts";
import { createORPCClient } from "@orpc/client";
import type { ContractRouterClient } from "@orpc/contract";
import { OpenAPILink } from "@orpc/openapi-client/fetch";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import { apiFetch } from "@packages/core-client/api/apiFetch.ts";
import { invalidate, queryPath } from "@packages/core-client/query/queryKeys.ts";
import { useEnvironmentVariable } from "@squide/firefly";
import { useMemo } from "react";

function createSegmentsListClient(baseUrl: string) {
    const link = new OpenAPILink(segmentsListContract, {
        url: `${baseUrl}/api/segments`,
        fetch: apiFetch
    });

    const client: ContractRouterClient<typeof segmentsListContract> = createORPCClient(link);
    const queryUtils = createTanstackQueryUtils(client, { path: queryPath("admin-settings", ["segments"]) });

    return { client, queryUtils };
}

export function useSegmentsListClient() {
    const apiBaseUrl = useEnvironmentVariable("apiBaseUrl");

    return useMemo(() => createSegmentsListClient(apiBaseUrl), [apiBaseUrl]);
}

export function useRenameSegmentMutationOptions() {
    const { queryUtils } = useSegmentsListClient();

    return queryUtils.renameSegment.mutationOptions({
        onSuccess: (_data, _variables, _onMutateResult, { client: queryClient }) => invalidate(queryClient, "segments")
    });
}

export function useDeleteSegmentsMutationOptions() {
    const { queryUtils } = useSegmentsListClient();

    return queryUtils.deleteSegments.mutationOptions({
        onSuccess: (_data, _variables, _onMutateResult, { client: queryClient }) => invalidate(queryClient, "segments")
    });
}
